import { useState, useMemo } from "react";
import { Button } from "@design-lab/shared/ui";
import { Tooltip, TooltipTrigger, TooltipContent } from "@design-lab/shared/ui/tooltip";
import { Info } from "lucide-react";

export type PlacementControlTooltipProps = {
  isDesktop: boolean;
};

export function PlacementControlTooltip({ isDesktop }: PlacementControlTooltipProps) {
  const [isHintOpen, setIsHintOpen] = useState(false);
  const mobileOnly = useMemo(
    () => (!isDesktop ? { onClose: () => setIsHintOpen(false) } : {}),
    [isDesktop]
  );

  return (
    <Tooltip open={isHintOpen} delayDuration={300} onOpenChange={setIsHintOpen}>
      <TooltipTrigger
        asChild
        data-testid="placement-control-tooltip"
        onClick={() => setIsHintOpen(true)}
      >
        <Button
          data-testid="placement-control-tooltip-button"
          variant="icon"
          size="icon_xs"
          aria-label="Placement information"
        >
          <Info className="size-4 text-gray-600" />
        </Button>
      </TooltipTrigger>
      <TooltipContent
        className="w-[315px] bg-blue-700 p-3 text-sm lg:w-fit lg:max-w-[430px]"
        arrowClassName="bg-blue-700 fill-blue-700"
        side={isDesktop ? "bottom" : "top"}
        align={isDesktop ? "start" : "center"}
        alignOffset={isDesktop ? -10 : 0}
        sideOffset={4}
        avoidCollisions={true}
        {...mobileOnly}
      >
        <p className="text-wrap">
          Design is auto-centered in this area. Fixed placement ensures consistent quality for every
          order.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
